import styled from 'styled-components';

export const LabelRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: baseline;
`;

export interface LabelTextProps {
  $color?: string;
}

export const LabelText = styled.span`
    font-size: inherit;
    line-height: inherit;
    color: ${(props) => props.theme.grey};
`;

export interface CounterProps {
  $okColor?: string;
  $overColor?: string;
}

export const CounterOver =  styled.span`
    font-size: inherit;
    line-height: inherit;
    white-space: nowrap;
    color: ${(props) => props.theme.red};
`;

export const CounterOk =  styled.span`
    font-size: inherit;
    line-height: inherit;
    white-space: nowrap;
    color: ${(props) => props.theme.stepInactiveColor};
`;